import type { Kpi } from '../kpi/kpi.interface';
import { KPI_GRANULARITY, KPI_KEYS } from '../kpi/kpi.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class KpiFactory extends ObjectFactory<Kpi> {
  protected getDefaults(): Kpi {
    return {
      ...baseDocumentFactory.build(),
      from: { day: 1, month: 9, year: 2026 },
      granularity: KPI_GRANULARITY.MONTH,
      key: KPI_KEYS.ORDER_KPIS,
      lastUsed: new Date('2026-01-01T00:00:00.000Z'),
      to: { day: 30, month: 9, year: 2026 },
    };
  }
}

export const kpiFactory = new KpiFactory();
